import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const KYC_SESSION_INITIAL = {
  isPrepareSessionError: false
} satisfies KycSessionState as KycSessionState;

type KycSessionState = {
  isPrepareSessionError: boolean;
};

export const kycSessionSlice = createSlice({
  name: "kycSession",
  initialState: KYC_SESSION_INITIAL,

  reducers: {
    setIsPrepareSessionError: (state, action: PayloadAction<boolean>) => {
      state.isPrepareSessionError = action.payload;
    }
  }
});

export const { setIsPrepareSessionError } = kycSessionSlice.actions;
